/**
 * `/organization/activity-reasons` — «Causali»: le voci con cui si rendicontano le ore (01-11-2026).
 *
 * Erano una sezione della rendicontazione (`/timesheet/reasons`), accanto al report del mese e
 * all'approvazione: chi configura entrava in una pagina di lavoro quotidiano per trovarle. Come in
 * Lares (`/erp-activity`) sono una pagina a sé: un catalogo dell'azienda, che si apre da
 * Organizzazione. L'indirizzo vecchio rinvia qui.
 *
 * Il contenuto è lo stesso di prima: `TimesheetReasonsConsole` sulla scrivania, `MobileTimesheetReasons`
 * sul telefono, che ha già la sua testata.
 */
import { createFileRoute } from '@tanstack/react-router';
import { IconListDetails } from '@tabler/icons-react';
import { MaePageHead, MaeShell } from '@/shared/desktop/MaeShell';
import { useIsMobileShell } from '@/shared/mobile/useIsMobileShell';
import { TimesheetReasonsConsole } from '@/features/timesheet/ReasonsConsole';
import { MobileTimesheetReasons } from '@/features/timesheet/mobile/MobileTimesheetReasons';

export const Route = createFileRoute('/_app/organization/activity-reasons')({ component: ActivityReasonsPage });

function ActivityReasonsPage() {
  const isMobile = useIsMobileShell();
  if (isMobile) return <MobileTimesheetReasons />;
  return (
    <MaeShell>
      <MaePageHead
        title="Causali"
        sub="Le voci con cui si rendicontano le ore: cosa è fatturabile, cosa è straordinario o trasferta, cosa chiede un progetto o un giustificativo."
        icon={<IconListDetails size={22} />}
      />
      <TimesheetReasonsConsole />
    </MaeShell>
  );
}
